module.exports = __webpack_public_path__ + "fonts/Averta-Regular.0db7c44.woff2";